import React, { useEffect, useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import { Typography } from '@material-ui/core';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Button from './Button';
import { DatePicker } from './DatePicker';
import { TextField } from './TextField';
import { CheckBox } from './CheckBox';
import { formatNumber, numberWithCommas, removeComma, restrictkeyupdown } from '../screens/common';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker as YearDatepicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from 'dayjs';
import TableSelect from './TableSelect';
import _ from "lodash";
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import Loading from './Order/Loading';
import { commonStrings } from './StringBundle';
import { useGlobalStyles } from './globalStyles';

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: '#feecda',
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(even)': {
      //   backgroundColor: theme.palette.action.hover,
    },
    '& .MuiOutlinedInput-input': {
      padding: '10px 14px'
    },

  },
}))(TableRow);

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
  noMinWidth: {
    minWidth: 'unset'
  },
  container: {
    width: '95%',
  },
  stickyContainer: {
    width: '100%',
    maxHeight: '60vh', 
    overflowY: "auto"
  },
  containerFull: {
    width: '100%'
  },
  noRecords: {
    minHeight: "100px",
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: "1.2rem !important",
    color:"#777",
  },
  stickyTableHeader: {
    backgroundColor: "#feecda",
    position: "sticky",
    top: 0,
    zIndex: 2,
  },
  noWrapScroll: {
    overflowX: 'auto',
    '& th': {
      whiteSpace: 'nowrap',
    },
  },
});

export default function BasicTable(props) {
  const classes = useStyles();
  const globalClasses = useGlobalStyles();
 
  const total = () => {
    if (props?.mrinOtherSpec && props?.mrinOtherSpec === true) {
      return props.rows;
    } else {
      if (props?.rowlength) {
        if (props.rowlength !== 0 && props.rowlength === props.rows.length) {
          return props?.rows?.map(row => parseFloat(removeComma(row[props?.totalColId]))).reduce((sum, i) => sum + i, 0);
        } else {
          return false;
        }
      } else {
        return props.rows?.map(row => parseFloat(row[props.totalColId] ? removeComma(row[props.totalColId]) : 0)).reduce((sum, i) => sum + i, 0);
      }
    }
  }
  // eslint-disable-next-line
  useEffect(async () => {
    await setTotalValue(total());
    // eslint-disable-next-line
  }, [props.rowlength]);

  const totalIndex = () => {
    return props.columns.findIndex(item => item.id === props.totalColId);
  }

  const [totalValue, setTotalValue] = useState(total())
  
  
  const EditableCell = (props) => {
    // We need to keep and update the state of the cell normally
    const [value, setValue] = useState(props.initialValue)

    const onChange = async e => {
      if (props.type === "date" || props.type === "yeardate") {
        await setValue(e)
        // updateMyData(props.index, props.id, e)
        
      } else {
        if (props.id && (props.id === 'dispatch_quantity' || props.id === 'delivered_spec' || props.id === 'expected_spec')) {
          if (e.target.value >= 0) {
            setValue(e.target.value)
          }
        } else {
          setValue(e.target.value)
        }
      }
    }

    const onClick = e => {
      props?.taxDelete ? props.handler.handleTaxClick(props.index) : props.handler.handleClick(props.index);
    }

    // We'll only update the external data when the input is blurred
    const onBlur = () => {
      updateMyData(props.index, props.id, value)
    }

    const onCloseYear = (e) => {
      updateMyData(props.index, props.id, value)
    }

    // If the initialValue is changed external, sync it up with our state
    useEffect(() => {
      setValue(props.initialValue)
      const totalVal = total();
      setTotalValue(totalVal);
    }, [props.initialValue])

    if (props.type === "date" && props?.disablePastDates && props?.disablePastDates === true) {
      return <DatePicker value={value === '-' ? new Date() : value} onChange={onChange} minDate={new Date()} onBlur={onBlur}></DatePicker>
    } else if (props.type === "date") {
      return <DatePicker value={value === '-' ? new Date() : value} onChange={onChange} onBlur={onBlur}></DatePicker>
    } else if (props.type === "yeardate" && props?.disablePastDates && props?.disablePastDates === true) {
      return (
        <LocalizationProvider dateAdapter={AdapterDayjs} className='yeardate1' sx={{width: '100%'}} >
          <DemoContainer components={["DatePicker"]}className='yeardate2' sx={{width: '100%'}}>
            <YearDatepicker disablePast={true} onChange={onChange} onBlur={onBlur} renderInput={{readOnly: true}} closeOnSelect={false} onClose={(e) => onCloseYear(e)} value={dayjs(value === '-' ? new Date() : value)} views={['year', 'month', 'day']} className='yeardate3' format={'DD/MM/YYYY'} />
          </DemoContainer>
        </LocalizationProvider>
      )
    } else if (props.type === "yeardate") {
      return (
        <LocalizationProvider dateAdapter={AdapterDayjs} className='yeardate1' sx={{width: '100%'}} >
          <DemoContainer components={["DatePicker"]}className='yeardate2' sx={{width: '100%'}}>
            <YearDatepicker onChange={onChange} onBlur={onBlur} onClose={(e) => onCloseYear(e)} renderInput={{readOnly: true}} closeOnSelect={false} value={dayjs(value === '-' ? new Date() : value)} views={['year', 'month', 'day']} className='yeardate3' format={'DD/MM/YYYY'} />
          </DemoContainer>
        </LocalizationProvider>
      )
    } else if (props.type === "button") {
      return <Button onClick={onClick} label={props.label}></Button>
    } else {
      return <TextField value={value} onChange={onChange} onBlur={onBlur} onWheel={event => document.activeElement.blur()} type={props.type} />
    }
  }

  const updateMyData = (rowIndex, columnId, val) => {
    props.rows.forEach((row, index) => {
      if (index === rowIndex) {
        row[columnId] = val;
      }
    })
    const totalVal = total();
    setTotalValue(totalVal);
    props.onUpdate && props.onUpdate(totalVal);
  }

  function sumOFValueText(){
    return props.totalLabelText ? props.totalLabelText : props.totalLabel === true ? 'Total:' : '';
  }

  function totalValueText() {
    return props.totalProd || props.totalProd === 0 ? props.totalProd : props.formatTotal ? formatNumber(totalValue, 2) : formatNumber(totalValue, 3);
  }
const renderTableRows = () => {
  if (props?.loadingInventory === true || props?.isLoading === true) {
    return (
      <StyledTableRow className={StyledTableRow}>
        <StyledTableCell className={StyledTableCell} colSpan={11}>
          <Loading />
        </StyledTableCell>
      </StyledTableRow>
    );
  }

  if (!props.inventoryTable || props.inventoryTable !== true) {
    if (!props.error && (!props.rows || props.rows.length === 0)) {
      return (
        <StyledTableRow className={StyledTableRow}>
          <StyledTableCell className={StyledTableCell} colSpan={props.columns.length}>
            <Typography className={classes.noRecords}>{commonStrings.noRecords}</Typography>
          </StyledTableCell>
        </StyledTableRow>
      );
    }

    return props.rows.map((row, index) => (
      <StyledTableRow className={StyledTableRow} key={row.name}>
        {props.columns.map((column) => {
          const value = row[column.id] !== '' ? row[column.id] : '-';

          return (
            <StyledTableCell className={StyledTableCell} key={column.id} align={column.align}>
              {column.isEditable === true && row['tax_name']?.toLowerCase() !== 'tds' ? (
                <EditableCell
                  initialValue={value}
                  index={index}
                  id={column.id}
                  type={column.type}
                  label={column.label}
                  handler={column.handler}
                  taxDelete={column?.taxDelete}
                  disablePastDates={column?.disablePastDates}
                />
              ) : column.clickable === true ? (
                <a onClick={() => column.onClick(row[column.id])} style={{ textDecoration: "underline" }} href="#">
                  {value}
                </a>
              ) : column.clickableLink === true ? (
                <a onClick={() =>column.onClickLink(row)}>
                  {value}
                </a>
              ) : (
                value
              )}
            </StyledTableCell>
          );
        })}
      </StyledTableRow>
    ));
  }

  return null;
};

 const renderServerError = () => {
    if (!props.error) return null;

    return (
      <StyledTableRow>
        <StyledTableCell colSpan={props.columns?.length || 1}>
          <Typography
            style={{
              color: '#d32f2f',
              textAlign: 'center',
              padding: '20px',
              fontWeight: 500
            }}
          >
            {props.error}
          </Typography>
        </StyledTableCell>
      </StyledTableRow>
    );
  };

function getContainerClass() {
  if(props.inventoryTable){
    return classes.containerFull;
  }else if(props.stickyHeader){
    return classes.stickyContainer;
  }else if(props.fullwidth){
    return classes.containerFull;
  }else{
    return classes.container;
  }
}

  return (
    <TableContainer component={Paper} className={`${getContainerClass()} ${props?.headerNoWrap ? classes.noWrapScroll : ''}`}
 sx={{ maxHeight: props.maxHeight }}>
      <Table className={props.noMinWidth ? classes.noMinWidth : classes.table} aria-label="simple table">
        {
          !props.hideHeader &&
          <TableHead className={props.stickyHeader ? classes.stickyTableHeader : null}>
            <StyledTableRow>
              {props.columns?.map((column) => (
                <StyledTableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                >
                  {column.label}
                </StyledTableCell>
              ))}
            </StyledTableRow>
          </TableHead>
        }

        <TableBody style={{ backgroundColor: '#fff' }}>        
  {renderServerError()}
          {props.inventoryTable && props.inventoryTable === true ? (
            (props.rows && props.rows.length > 0) || (props?.isLoading === true) ? (
              props.rows.map((row, index) => (
                <StyledTableRow key={row.name}>
                  {(props?.isLoading === true) ? (
                      <StyledTableCell colSpan={props.colSpanInventory}>
                        <Loading />
                      </StyledTableCell>
                  ) : row.netSuiteItemId === '' ? (
                    <>
                      <StyledTableCell>
                        {row?.item_name}
                      </StyledTableCell>
                      <StyledTableCell colSpan={props.colSpanInventory}>
                        <p style={{ textAlign: 'center' }}>{commonStrings.noRecordinNetsuite}</p>
                      </StyledTableCell>
                    </>
                  ) : (<>
                    {props.columns.map((column) => {
                      const value = row[column.id] !== '' ? row[column.id] : '-';
                      return (
                        <StyledTableCell>
                          <p>{value}</p>
                        </StyledTableCell>
                      );
                    })}
                  </>
                  )}
                </StyledTableRow>
              ))
            ) : (
              // No records found message if rows is null or empty
              !props.loadingInventory && (
                <StyledTableRow>
                  <StyledTableCell colSpan={props.columns?.length || 1}>
                    <Typography variant="h6" className={globalClasses.basicTableNoRecords}>
                      {commonStrings.noRecords}
                    </Typography>
                  </StyledTableCell>
                </StyledTableRow>
              )
            )
          ) : null}
          
          {!props.hasError && renderTableRows()}
            {props.quoteSum && props.quoteSum===true &&  (
              <StyledTableRow>
                <StyledTableCell><b>Total GC Price:</b></StyledTableCell>
                <StyledTableCell></StyledTableCell>
                <StyledTableCell></StyledTableCell>
                <StyledTableCell></StyledTableCell>
                <StyledTableCell></StyledTableCell>
                <StyledTableCell></StyledTableCell>                
                <StyledTableCell style={{ textAlign:"right", paddingRight:'60px' }}><b>{_.isNaN(props.currentgcprice)?'-':(props.currentgcprice.toFixed(2))}</b></StyledTableCell>
                <StyledTableCell  style={{ textAlign:"right" , paddingRight:'76px'}}><b>{_.isNaN(props.totalGCprice)?'-':(props.totalGCprice.toFixed(2))}</b></StyledTableCell>
              </StyledTableRow>
            )}
        </TableBody>
        {
          props.rows !== null && props.rows?.length > 0 && props.hasTotal &&
          <TableRow className={StyledTableRow}>
            <StyledTableCell style={{ textAlign : props.alignCss || 'unset'}} colSpan={props.colSpan || totalIndex() - 1}>{sumOFValueText()}</StyledTableCell>
            <StyledTableCell>{totalValueText()}</StyledTableCell>
            {props.tableSixthRow !== undefined &&
              <StyledTableCell>{formatNumber(props.tableSixthRow, 3)}</StyledTableCell>
            }
          </TableRow>
        }
        {props.otherfactorCheck &&
          <>
            <StyledTableRow>
              <StyledTableCell><b>Additional Rate(MD) </b></StyledTableCell>
              
              {props?.currentpricerequested === 'both' ? <>
                <StyledTableCell>
                  <input type='number'
                  className='numberUpDown'
                    defaultValue={props.allData?.additionalrate}
                    onChange={(e) => props?.AdditionalCharges('currentAdditional', e.target.value)}
                    onKeyDown={(e)=> restrictkeyupdown(e)} 
                    onWheel={(e)=> e.target.blur()}
                    disabled={props?.enablepriceapprovebutton || props?.checkboxdisal}
                  />
                </StyledTableCell>
               
                <StyledTableCell>
                  <input type='number'
                   className='numberUpDown'
                    defaultValue={props.allData?.additionalrate}
                     disabled={props?.enablepriceapprovebutton || props?.checkboxdisal}
                    onKeyDown={(e)=> restrictkeyupdown(e)} 
                    onWheel={(e)=> e.target.blur()}
                    onChange={(e) => props?.AdditionalCharges('stockAdditional', e.target.value)}
                  /></StyledTableCell> </>
                   :
                props?.currentpricerequested === "Current" ?
                  <StyledTableCell>
                    <input type='number'
                     className='numberUpDown'
                     onKeyDown={(e)=> restrictkeyupdown(e)} 
                     onWheel={(e)=> e.target.blur()}
                      defaultValue={props.allData?.current_price_checked === true? props.allData?.additionalrate:0}
                      onChange={(e) => props?.AdditionalCharges('currentAdditional', e.target.value)}
                       disabled={props?.enablepriceapprovebutton || props?.checkboxdisal}
                    />
                  </StyledTableCell> :
                  <StyledTableCell>
                    <input type='number'
                     className='numberUpDown'
                     onKeyDown={(e)=> restrictkeyupdown(e)} 
                     onWheel={(e)=> e.target.blur()}
                      defaultValue={props.allData?.stock_price_checked === true?props.allData?.additionalrate:0}
                      disabled= {props?.enablepriceapprovebutton || props?.checkboxdisal}
                      onChange={(e) => props?.AdditionalCharges('stockAdditional', e.target.value)}
                    /></StyledTableCell>
                  }
                   <StyledTableCell>
                    <input type='number'
                     className='numberUpDown'
                      defaultValue={props.allData?.productioncost_checked === true?props.allData?.additionalrate:0}
                      disabled={ props?.checkboxdisal}
                      onKeyDown={(e)=> restrictkeyupdown(e)} 
                      onWheel={(e)=> e.target.blur()}
                      onChange={(e) => props?.AdditionalCharges('productionAdditional', e.target.value)}
                    /></StyledTableCell>
            </StyledTableRow>
            

            { (props?.quoteItemDatas?.quote_category === "Export" || props?.quoteItemDatas?.quote_category === "Merchant Export") ?   <StyledTableRow>
              <StyledTableCell><b>Total(USD) </b></StyledTableCell>
              {props?.currentpricerequested === "both" ?
                <>
                  <StyledTableCell><b>{props?.currentbaseprice ? parseFloat(props?.currentbaseprice).toFixed(2) : 0.00}</b></StyledTableCell>
                  <StyledTableCell><b>{props?.stockbaseprice ? parseFloat(props?.stockbaseprice).toFixed(2) : 0.00}</b></StyledTableCell>
                </> :
                props?.currentpricerequested === "Current" ?
                  <StyledTableCell><b>{props?.currentbaseprice ? parseFloat(props?.currentbaseprice).toFixed(2) : 0.00}</b></StyledTableCell> :
                  <StyledTableCell><b>{props?.stockbaseprice ? parseFloat(props?.stockbaseprice).toFixed(2) : 0.00}</b></StyledTableCell>}
                  <StyledTableCell><b>{props?.totalProductioncost ? parseFloat(props?.totalProductioncost).toFixed(2) : 0.00}</b></StyledTableCell>
            </StyledTableRow>:
              <StyledTableRow>
               <StyledTableCell><b>Total({props?.quoteItemDatas?.currency_code})</b></StyledTableCell>
               {props?.currentpricerequested === "both" ?
                 <>
                   <StyledTableCell><b>{props?.currentbaseprice ? parseFloat(props?.currentbaseprice).toFixed(2) : 0.00}</b></StyledTableCell>
                   <StyledTableCell><b>{props?.stockbaseprice ? parseFloat(props?.stockbaseprice).toFixed(2) : 0.00}</b></StyledTableCell>
                 </> :
                 props?.currentpricerequested === "Current" ?
                   <StyledTableCell><b>{props?.currentbaseprice ? parseFloat(props?.currentbaseprice).toFixed(2) : 0.00}</b></StyledTableCell> :
                   <StyledTableCell><b>{props?.stockbaseprice ? parseFloat(props?.stockbaseprice).toFixed(2) : 0.00}</b></StyledTableCell>}
                   <StyledTableCell><b>{props?.totalProductioncost ? parseFloat(props?.totalProductioncost).toFixed(2) : 0.00}</b></StyledTableCell>
             </StyledTableRow>
          }

            
            <StyledTableRow>
              <StyledTableCell><b> Margin(%)   <br/> </b></StyledTableCell>
              {props?.currentpricerequested === "both" ?
                <>
                  <StyledTableCell><b>-</b></StyledTableCell>
                  <StyledTableCell><b>{props?.currentbaseprice ? ((((props?.stockbaseprice) - (props?.currentbaseprice))/(props?.currentbaseprice) )*100)?.toFixed(2) : 0.00}</b></StyledTableCell>
                </> :
                props?.currentpricerequested === "Current" ?
                  <StyledTableCell><b>-</b></StyledTableCell> :
                  <StyledTableCell><b>0</b></StyledTableCell>
                  }
                   {props?.isProduction === true ?
                    <StyledTableCell><b>{props?.currentpricerequestedval === true ? ((((props?.totalProductioncost) - parseFloat(props?.currentbaseprice))/parseFloat(props?.currentbaseprice) )*100)?.toFixed(2) : ((((props?.totalProductioncost) - parseFloat(props?.stockbaseprice))/parseFloat(props?.stockbaseprice) )*100)?.toFixed(2)}</b></StyledTableCell> :
                  <StyledTableCell><b>{props?.currentbaseprice ?((((props?.totalProductioncost) - (props?.currentbaseprice))/(props?.currentbaseprice) )*100)?.toFixed(2) : 0.00}</b></StyledTableCell>
                  
                  }
                  
            </StyledTableRow>
         
            { (props?.quoteItemDatas?.quote_category === "Export" || props?.quoteItemDatas?.quote_category === "Merchant Export") && <StyledTableRow>
              <StyledTableCell><b>Total({props?.quoteItemDatas?.currency_code})</b></StyledTableCell>
              {props?.currentpricerequested === "both" ?
                <>
                  <StyledTableCell><b>{props?.currentbaseprice ? parseFloat(props?.currentbaseprice*props?.quoteItemDatas?.usd_conversion_rate).toFixed(2) : 0.00}</b></StyledTableCell>
                  <StyledTableCell><b>{props?.stockbaseprice ? parseFloat(props?.stockbaseprice*props?.quoteItemDatas?.usd_conversion_rate).toFixed(2) : 0.00}</b></StyledTableCell>
                </> :
                props?.currentpricerequested === "Current" ?
                  <StyledTableCell><b>{props?.currentbaseprice ? parseFloat(props?.currentbaseprice*props?.quoteItemDatas?.usd_conversion_rate).toFixed(2) : 0.00}</b></StyledTableCell> :
                  <StyledTableCell><b>{props?.stockbaseprice ? parseFloat(props?.stockbaseprice*props?.quoteItemDatas?.usd_conversion_rate).toFixed(2) : 0.00}</b></StyledTableCell>}
                  <StyledTableCell><b>{props?.totalProductioncost ? parseFloat(props?.totalProductioncost*props?.quoteItemDatas?.usd_conversion_rate).toFixed(2) : 0.00}</b></StyledTableCell>
            </StyledTableRow>}

            <StyledTableRow>
              <StyledTableCell></StyledTableCell>             
              {props?.currentpricerequested === "both" ? <>
                <StyledTableCell><CheckBox checked={props?.current_price_checked} name='current_price_checked' onChange={(e) => props?.priceChecked('current_price_checked', e.target.checked)} /></StyledTableCell>
                <StyledTableCell><CheckBox checked={props?.stock_price_checked}  name='stock_price_checked' onChange={(e) => props?.priceChecked('stock_price_checked', e.target.checked)} /></StyledTableCell>
              </> :
                props?.currentpricerequested === "Current" ?
                  <StyledTableCell><CheckBox checked={props?.current_price_checked} disabled={props?.enablepriceapprovebutton ||  props?.checkboxdisal} name='current_price_checked' onChange={(e) => props?.priceChecked('current_price_checked', e.target.checked)} /></StyledTableCell> :
                  <StyledTableCell><CheckBox checked={props?.stock_price_checked} disabled={props?.enablepriceapprovebutton ||  props?.checkboxdisal} name='stock_price_checked' onChange={(e) => props?.priceChecked('stock_price_checked', e.target.checked)} /></StyledTableCell>}
                  {props?.hasProduction ? <StyledTableCell><CheckBox checked={props?.productioncost_checked} disabled={props?.enablepriceapprovebutton || props?.checkboxdisal} name='productioncost_checked' onChange={(e) => props?.priceChecked('productioncost_checked', e.target.checked)} /></StyledTableCell>: 
                  <StyledTableCell></StyledTableCell>}
            </StyledTableRow>
          </>
        }
      </Table>
    </TableContainer>
  );
}